import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DefaultLayout from "layouts/Default";
import "./index.scss";
import ContentPageProvider from "components/content/ContentPageProvider";
import TitleText from "../../../components/titleText";
import VideoHero from "../../../components/videoHero";
// import Banner from "../../../components/banner";
import BookingEnquiryForm from "components/bookings/BookingEnquiryForm";
import bg from "../../../assets/img/steps/geo-2.svg";

export class AboutPage extends Component<RouteComponentProps> {
  render() {
    return (
      <DefaultLayout id="about-page">
        <ContentPageProvider url={this.props.location.pathname}>
          {/* <Banner /> */}
          <TitleText
            code="titleText"
            backgroundAsset={bg}
            backgroundAssetPosition={{ top: "10%", left: "70%" }}
          />
          <VideoHero code="videoHero" />
          <TitleText code="textOnly" />
          <BookingEnquiryForm />
        </ContentPageProvider>
      </DefaultLayout>
    );
  }
}

export default AboutPage;
